
import { defineComponent } from '@nuxtjs/composition-api'
import elementSeoText from '~/components/element/elementSeoText.vue'

export default defineComponent({
  props: {
    pageroute: {
      type: String,
      required: true,
    },
  },
  components: {
    elementSeoText,
  },
  setup(props) {
    const pageRoute = props.pageroute
    let pageName = ''
    let pageStr = ''

    if (pageRoute.search('___') !== -1) {
      pageName = pageRoute.substr(0, pageRoute.length - 5)

      if (pageName.search('___') !== -1) {
        pageName = pageName.substr(0, pageName.length - 5)
      }

      pageStr = 'pages.' + pageName
    }

    const NODE_ENV = process.env.NODE_ENV

    return { pageRoute, pageName, pageStr, NODE_ENV }
  },
})
